import { render, staticRenderFns } from "./BaseSectionTitle.vue?vue&type=template&id=58caead0&scoped=true&"
import script from "./BaseSectionTitle.vue?vue&type=script&lang=js&"
export * from "./BaseSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseSectionTitle.vue?vue&type=style&index=0&id=58caead0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58caead0",
  null
  
)

export default component.exports